import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Variants } from "../variants/variants";
import AddToCart from "./add-to-cart";
import React from "react";
import { useVariantsStore } from "../../store/variants";
import { useModalStore } from "../../store/modal";
import { useGlobalStore } from "../../store/global";
import { addCartItem } from "../../store/cart";
import { computePriceWithDiscount, formatPrice, roundPrice } from "../../utils";
import { isSellable } from "../product/utils";
// TODO refactoring
export default function AddToCartVariant({ ...product }) {
    const settings = useGlobalStore((state) => state.config.template_settings);
    const texts = useGlobalStore((state) => state.config.texts);
    const api = useGlobalStore((state) => state.config.api);
    const currency = useGlobalStore((state) => state.config.currency);
    const selectedVariant = useVariantsStore((state) => state.selectedVariant);
    const reset = useVariantsStore((state) => state.reset);
    const open = useModalStore((state) => state.open);
    const close = useModalStore((state) => state.close);
    const customer_discount = useGlobalStore((state) => state.config.customer?.discount ?? 0);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    let discount = (selectedVariant ? selectedVariant.discount : product.discount) || 0;
    if (customer_discount > 0) {
        discount = discount > 0 ? discount * (customer_discount / 100) : customer_discount;
    }
    const priceWithVat = roundPrice(selectedVariant?.price_with_vat ?? product.price_with_vat, currency);
    const priceWithVatAfterDiscount = roundPrice(computePriceWithDiscount(priceWithVat, discount), currency);
    const variantImage = selectedVariant?.images[0] ?? product.image;
    const quantity = 1;
    const sellable = isSellable(selectedVariant ? selectedVariant : product, quantity);
    const unit = settings.product_detail.show_unit.enabled
        ? ` / ${product.unit}`
        : "";
    async function handleAdd() {
        setIsSubmitting(true);
        try {
            await addCartItem(api.cart.add, product.id, quantity, selectedVariant?.id);
            open({
                title: texts["text342"],
                content: _jsx(AddToCart, { ...product }),
                onClose: () => reset(),
            });
        }
        catch (err) {
            console.log(err);
        }
        finally {
            setIsSubmitting(false);
        }
    }
    return (_jsxs("div", { className: "react-add-to-cart text-center text-md-left", children: [_jsx("div", { className: "divider my-4" }), _jsxs("div", { className: "d-flex flex-column flex-md-row align-items-center align-items-md-start", children: [variantImage && (_jsx("img", { src: variantImage.url, alt: variantImage.alt, className: "react-add-to-cart__image mr-4" })), _jsxs("div", { className: "d-flex flex-column", children: [_jsx("span", { className: "react-add-to-cart__title mb-4", children: product.title }), _jsx(Variants, {}), _jsx("span", { className: "react-add-to-cart__title mt-4", children: `${quantity}x ${formatPrice(priceWithVatAfterDiscount, currency)}${unit}` })] })] }), _jsx("div", { className: "divider my-4" }), _jsxs("div", { className: "d-flex flex-column flex-md-row", children: [_jsx("button", { className: "secondary w-100 mr-md-2", onClick: () => close(), disabled: isSubmitting, children: texts["text208"] }), _jsx("button", { onClick: handleAdd, className: "primary w-100 ml-md-2 mt-2 mt-md-0", disabled: !sellable || !selectedVariant || isSubmitting, children: texts["text227"] })] })] }));
}
